module.exports = __webpack_public_path__ + "img/prd_pack.89b61577.png";